module.exports = __webpack_public_path__ + "media/images/talent/case-reward01-46953d07ef32e387ba4cb4027ac51cc0.png";